export default __webpack_public_path__ + "static/media/59.d2f877a5.jpeg";